import React, { useState, useEffect, useContext } from 'react';
import LVP from './pages/LVP';
import TrailerBurndown from './pages/TrailerBurndown';
import DeptStaffing from './pages/DeptStaffing';
import ShiftHistory from './pages/ShiftHistory';
import RateManager from './pages/RateManager';
import FCLMLive from './pages/FCLMLive';
import Wash from './pages/Wash';
import Heapmat from './pages/Heapmat';
import Hapmeat from './pages/Hapmeat';
import Heatmap from './pages/Heatmap';
import Meesa from './pages/Meesa';
import Yousa from './pages/Yousa';
import Weesa from './pages/Weesa';
import Fallin from './pages/Fallin';
import Midi from './pages/Midi';
import MSM from './pages/MSM';
import Quarterly from './pages/Quarterly';
import DeptWash from './pages/DeptWash';
import SWC from './pages/SWC';
import EOLScans from './pages/EOLScans';
import RollCall from './pages/RollCall';
import DDDAlps from './pages/DDDAlps';
import OnsitePending from './pages/OnsitePending';
import Binks from "./pages/Binks";
import DetailedTrailerPlan from './pages/DetailedTrailerPlan';
import UnifiedPortal from './pages/UnifiedPortal';
import Alps from './pages/Alps';
import IPT from './pages/IPT';
import FAQ from './pages/FAQ';
import NarcsRUs from './pages/NarcsRUs';
import DataHealth from './pages/DataHealth';
import ChangeLog from './pages/ChangeLog';
import YardPerformance from './pages/YardPerformance';
import JamControl from './pages/JamControl';
import SorterMap from './pages/SorterMap';
import FluidTracker from './pages/FluidTracker';
import ReceiveActivity from './pages/ReceiveActivity';
import { AuthContext } from './AuthGate';
import { SITES, fetchWithFallback } from './referenceData';
import './App.css';

const API = window.location.hostname.includes('proxy.devspaces') ? '' : 'https://22tp4u1f2h.execute-api.us-west-2.amazonaws.com/prod';

function App() {
  const { user, logout } = useContext(AuthContext);
  const [page, setPage] = useState('fclm');
  const [site, setSite] = useState('OLM1');
  const [sites, setSites] = useState(SITES);
  const [openMenu, setOpenMenu] = useState(null);

  // Narcs'r'us is restricted to a small allowlist.
  const NARCS_ALLOWLIST = ['walsaide', 'jenbre', 'jjacbso', 'echevt'];
  const canSeeNarcs = NARCS_ALLOWLIST.includes((user?.username || '').toLowerCase());
  // Data Health (DevSpace pull status) — owner only for now. UI gate, like Narcs'r'us.
  const DATA_HEALTH_ALLOWLIST = ['walsaide'];
  const canSeeDataHealth = DATA_HEALTH_ALLOWLIST.includes((user?.username || '').toLowerCase());

  const NAV_CATEGORIES = [
    { label: 'Daily Execution', tabs: [['fclm', 'Hourly'], ['quarterly', 'Quaterly'], ['midi', 'MIDI'], ['deptwash', 'Dept Wash'], ['msm', 'MSM'], ['fallin', 'FALLIN'], ['swc', 'SWC'], ['eolscans', 'IDRT'], ['rollcall', 'Roll Call'], ['yardperf', 'Yard Performance'], ['jamcontrol', 'Jam Control Station'], ['sortermap', 'Sorter Map'], ['fluidtracker', 'Fluid Tracker'], ['receiveactivity', 'Receive Activity'], ...(canSeeNarcs ? [['narcs', "Narcs'r'us"]] : [])] },
    { label: 'Weekly Planning', tabs: [['main', 'LVP'], ['trailerburndown', 'Trailer Burndown'], ['binks', 'Vessel Forecast'], ['trailerplan', 'Detailed Trailer Plan'], ['unifiedportal', 'Unified Portal'], ['alps', 'ALPS'], ['ipt', 'IPT']] },
    { label: 'Daily Reporting', tabs: [['dddalps', 'DDD/ALPS'], ['onsitepending', 'Onsite Pending'], ...(canSeeDataHealth ? [['datahealth', 'Data Health']] : []), ['changelog', 'Change Request & QA Log']] },
    { label: 'Rate Planning', tabs: [['meesa', 'Bottoms Up Forecast'], ['yousa', 'Tops Down Forecast'], ['weesa', 'HWM Comparison']] },
    { label: 'Hatmeap', tabs: [['heapmat', 'Heapmat'], ['hapmeat', 'Hapmeat'], ['heatmap', 'Heatmap'], ['history', 'History']] },
  ];

  // Sites still being onboarded only see the tabs whose data is wired for
  // them. Sites not listed here (OLM1, SIX7) see every tab, unchanged.
  const ONBOARDING_TABS = ['fclm', 'quarterly', 'unifiedportal', 'alps', 'ipt', 'meesa', 'yousa', 'weesa'];
  const SITE_TAB_ALLOWLIST = { SBD3: ONBOARDING_TABS, SCK8: [...ONBOARDING_TABS, 'changelog'] };
  // Tabs that exist ONLY for one site (hidden everywhere else, including OLM1).
  const SITE_ONLY_TABS = { changelog: 'SCK8', fluidtracker: 'OLM1', receiveactivity: 'OLM1' };
  const siteTabs = SITE_TAB_ALLOWLIST[site];
  const isTabAllowed = (key) => (SITE_ONLY_TABS[key] ? SITE_ONLY_TABS[key] === site : key === 'faq' || key === 'datahealth' || !siteTabs || siteTabs.includes(key));
  const navCategories = NAV_CATEGORIES
    .map(cat => ({ ...cat, tabs: cat.tabs.filter(([key]) => isTabAllowed(key)) }))
    .filter(cat => cat.tabs.length > 0);
  // Render guard: a hidden tab can't show even if it was selected before a site switch.
  const shown = isTabAllowed(page) ? page : 'fclm';

  // Switching to a restricted site while on a hidden tab lands on Hourly.
  useEffect(() => {
    if (!isTabAllowed(page)) setPage('fclm');
  }, [site]);

  useEffect(() => {}, []);

  return (
    <div className="app">
      <header className="header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/jarjarturkey.png" alt="JarJar" style={{ height: 40, width: 'auto', borderRadius: 4 }} />
          <div><h1>JAR JAR</h1><span style={{ fontSize: '0.65rem', color: '#666', display: 'block', marginTop: -4 }}>Job Allocation Report & Job Allocation Report</span></div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <select value={site} onChange={e => setSite(e.target.value)} style={{ padding: '6px 12px', borderRadius: 4, border: '1px solid #ccc', fontWeight: 600 }}>
            {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <nav>
            {navCategories.map(cat => {
              const inCat = cat.tabs.some(([key]) => key === page);
              return (
                <div
                  key={cat.label}
                  style={{ position: 'relative', display: 'inline-block' }}
                  onMouseEnter={() => setOpenMenu(cat.label)}
                  onMouseLeave={() => setOpenMenu(m => (m === cat.label ? null : m))}
                >
                  <button className={inCat ? 'active' : ''} onClick={() => setOpenMenu(m => (m === cat.label ? null : cat.label))}>
                    {cat.label} ▾
                  </button>
                  {openMenu === cat.label && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, background: '#fff', border: '1px solid #ccc', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', zIndex: 100, minWidth: 130, display: 'flex', flexDirection: 'column', padding: 2 }}>
                      {cat.tabs.map(([key, label]) => (
                        <button
                          key={key}
                          className={page === key ? 'active' : ''}
                          onClick={() => { setPage(key); setOpenMenu(null); }}
                          style={{ textAlign: 'left', whiteSpace: 'nowrap', width: '100%' }}
                        >
                          {label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            <button className={page === 'faq' ? 'active' : ''} onClick={() => setPage('faq')}>FAQ</button>
          </nav>
        </div>
      </header>
      <main>
        {shown === 'main' && <LVP api={API} site={site} />}
        {shown === 'trailerburndown' && <TrailerBurndown api={API} site={site} />}
        {shown === 'staffing' && <DeptStaffing api={API} site={site} />}
        {shown === 'fclm' && <FCLMLive api={API} site={site} />}
        {shown === 'wash' && <Wash api={API} site={site} />}
        {shown === 'heapmat' && <Heapmat api={API} site={site} />}
        {shown === 'hapmeat' && <Hapmeat api={API} site={site} />}
        {shown === 'heatmap' && <Heatmap api={API} site={site} />}
        {shown === 'meesa' && <Meesa api={API} site={site} />}
        {shown === 'yousa' && <Yousa api={API} site={site} />}
        {shown === 'weesa' && <Weesa api={API} site={site} />}
        {shown === 'fallin' && <Fallin api={API} site={site} />}
        {shown === 'binks' && <Binks api={API} site={site} />}
        {shown === 'trailerplan' && <DetailedTrailerPlan api={API} site={site} />}
        {shown === 'unifiedportal' && <UnifiedPortal api={API} site={site} />}
        {shown === 'alps' && <Alps api={API} site={site} />}
        {shown === 'ipt' && <IPT api={API} site={site} />}
        {shown === 'midi' && <Midi api={API} site={site} />}
        {shown === 'msm' && <MSM api={API} site={site} />}
        {shown === 'quarterly' && <Quarterly api={API} site={site} />}
        {shown === 'deptwash' && <DeptWash api={API} site={site} />}
        {shown === 'swc' && <SWC api={API} site={site} />}
        {shown === 'eolscans' && <EOLScans api={API} site={site} />}
        {shown === 'rollcall' && <RollCall api={API} site={site} />}
        {shown === 'narcs' && canSeeNarcs && <NarcsRUs api={API} site={site} />}
        {shown === 'datahealth' && canSeeDataHealth && <DataHealth api={API} />}
        {shown === 'changelog' && site === 'SCK8' && <ChangeLog api={API} site={site} user={user?.username} />}
        {shown === 'jamcontrol' && <JamControl api={API} site={site} user={user?.username} />}
        {shown === 'sortermap' && <SorterMap api={API} site={site} user={user?.username} />}
        {shown === 'fluidtracker' && site === 'OLM1' && <FluidTracker api={API} site={site} />}
        {shown === 'receiveactivity' && site === 'OLM1' && <ReceiveActivity api={API} site={site} />}
        {shown === 'yardperf' && <YardPerformance api={API} site={site} canSeeDrivers={canSeeNarcs} />}
        {shown === 'dddalps' && <DDDAlps api={API} site={site} />}
        {shown === 'onsitepending' && <OnsitePending api={API} site={site} />}
        {shown === 'faq' && <FAQ />}
        {shown === 'history' && <ShiftHistory api={API} site={site} />}
        {shown === 'rates' && <RateManager api={API} site={site} />}
      </main>

      {/* Bright scrolling ticker — only for a specific allowlist of users.
          Fixed to the bottom, always visible, cannot be dismissed. */}
      {['drodehea'].includes((user?.username || '').toLowerCase()) && (() => {
        const items = [
          'Texas Longhorns (4-2) 24 - Oklahoma (3-3) 27',
          'Texas Longhorns (4-2) 24 - Florida (5-2) 27',
          'Tampa Bay Rays 1 - New York Yankees 0 (ALDS Game 1)',
          'Tampa Bay Rays 5 - New York Yankees 2 (ALDS Game 2)',
          'Tampa Bay Rays 4 - New York Yankees 3 (ALDS Game 3)',
          'Fun fact, when the Dallas Cowboys last won the Super Bowl (January 1996), Google had not even been invented yet (founded September 1998).',
          'Fun fact, the Phoenix Suns have played 58 seasons in the NBA without winning a single championship, giving them the highest all-time winning percentage of any franchise in North American professional sports to never win a title.',
          'Aaron Judge current location: Cancun',
          'NFC East Division is currently being led by: "9" and the New York Giants',
          'Arch Manning currently has a 0.4% chance of winning the Heisman, lower than Saquon Barkleys chance of winning NFL MVP',
          'Dallas Cowboys 13 - Green Bay Packers 23 (Micah Parsons reportedly did more to help the Cowboys win than Dakota Preskot who threw 2 INTs {should have been 3})',
        ];
        // Duplicate the sequence so the loop is seamless.
        const line = items.join('\u00A0\u00A0\u00A0\u2022\u00A0\u00A0\u00A0');
        return (
          <div style={{
            position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 2147483647,
            height: 34, background: '#ff2d95', color: '#ffffff', overflow: 'hidden',
            borderTop: '2px solid #c40063', boxShadow: '0 -2px 10px rgba(0,0,0,.35)',
            fontWeight: 800, fontSize: '0.95rem', display: 'flex', alignItems: 'center',
            fontFamily: 'Arial, sans-serif', letterSpacing: '0.3px', pointerEvents: 'none',
          }}>
            <style>{`@keyframes jarjarTicker { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }`}</style>
            <div style={{
              display: 'inline-block', whiteSpace: 'nowrap', paddingLeft: '100%',
              animation: 'jarjarTicker 60s linear infinite',
              willChange: 'transform',
            }}>
              <span style={{ paddingRight: 60 }}>{line}</span>
              <span style={{ paddingRight: 60 }}>{line}</span>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

export default App;
